export default "__VITE_ASSET__b0405b8e__"